import React, {useEffect, useState} from "react";
import {post} from "../utils/FetchUtil";
import {
    isCardDesignTemp,
    isMessageTemp,
    isQrSettingTemp,
    isWrapTemp,
} from "../const/TemplateConst";
import OptionTemplateItem from "../components/list/OptionTemplateItem";
import {Button, Card, CardBody, CardImg, CardText} from "react-bootstrap";
import {img} from "../utils/ImageUtil.ts";
import {isNotEmpty} from "../utils/CommonUtil.ts";
import {popConfirm, popErrors} from "../utils/MessageUtil.ts";

interface OrderDetailTemplateProps{
    dto?:OrderInputTemplateDto;
    seal_type?: boolean;
    committed?:boolean;
    handleClick?:(dto:OrderInputTemplateDto | null | undefined) => void;
    handleDeallocated?:(dto:OrderInputTemplateDto | null | undefined) => void;
    handleClickEntry?:(dto:OrderInputTemplateDto | null | undefined) => void;
}

const OrderDetailTemplate:React.FC<OrderDetailTemplateProps> = ({
    dto = {},
    seal_type = false,
    committed = false,
    handleClick = () => {},
    handleDeallocated = () => {},
    handleClickEntry = () => {},
}) => {
    const [templateDto, setTemplateDto] = useState<OrderInputTemplateDto | null | undefined>(null);
    useEffect(() => {
        if(dto){
            if(dto.template_id === null || dto.template_id === undefined || dto.template_id === -1){
                setTemplateDto({
                    template_id: dto.template_id,
                    template_kbn: dto.template_kbn,
                    template_name: dto.template_name,
                    image_path: dto.image_path,
                    wrap_image_path: dto.wrap_image_path,
                    inner_noshi: dto.inner_noshi,
                    order_slipnumber: dto.order_slipnumber,
                    order_detailnumber: dto.order_detailnumber,
                    ondemand_card_order: dto.ondemand_card_order
                });
            }else{
                post<OrderInputTemplateDto>({
                    action: "/api/template/order_detail/info",
                    data: dto,
                })
                    .then((data) => {
                        if(data){
                            data.ondemand_card_order = dto.ondemand_card_order;
                            setTemplateDto(data);
                        }
                    })
                    .catch((reason) => {
                        console.log(reason);
                    });
            }
        }
    }, [dto]);
    const onClickTemplate = () => {
        if(!seal_type){
            if(isMessageTemp(templateDto?.template_kbn) || !committed){
                handleClick( templateDto );
            }
        }
    }
    const onClickDeallocate = () => {
        if(isMessageTemp(templateDto?.template_kbn) || !committed){
            popConfirm(
                "割り当てるオリジナルカードの指定を解除します。よろしいですか？",
                () => {
                    post<OrderInputTemplateDto>({
                        action: "/api/template/deallocate",
                        data: templateDto as OrderInputTemplateDto,
                    })
                        .then((data) => {
                            if(data !== null && data !== undefined){
                                setTemplateDto(data);
                                handleDeallocated( data );
                            }
                        })
                        .catch((reason) => {
                            popErrors(reason.message);
                        });
                }
            );
        }
    }
    const onClickEntry = () => {
        if(handleClickEntry){
            handleClickEntry( templateDto );
        }
    }
    const openApplySitePreview = (dto: OrderInputTemplateDto) => {
        const newWindow = window.open('', '_blank');
        if(!newWindow){
            return;
        }
        newWindow.document.write(`<p>処理中... しばらくお待ちください。.</p>`);
        post<OrderInputTemplateDto>({
            action: "/api/order/apply/preview",
            data: dto
        })
            .then((data) => {
                if(data !== null && isNotEmpty(data?.apply_goods_preview_url)){
                    //window.open(data?.apply_goods_preview_url, '_blank');
                    newWindow.location.href = data?.apply_goods_preview_url as string;
                }else{
                    newWindow.close();
                }
            })
            .catch((reason) => {
                newWindow.close();
                console.log(reason.message);
            });
    }
    if(!dto || !dto.template_kbn){
        return <></>
    }else if(isCardDesignTemp(dto?.template_kbn)){
        if(committed && !isNotEmpty(templateDto?.template_id)){
            return <></>;
        }
        if(isNotEmpty(templateDto?.template_id)){
            return <Card className="allocate-template-card border-0">
                <CardImg variant={"top"}
                         src={img(templateDto?.image_path)}
                         className={`${committed?'original-design-committed':'original-design'}`}
                         onClick={onClickTemplate}/>
                <CardBody>
                    <div className="my-design-allocate-buttons">
                        <Button variant={"danger"}
                                className={committed ? 'd-none' : ''}
                                onClick={onClickDeallocate}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eraser-fill" viewBox="0 0 16 16">
                                <path
                                    d="M8.086 2.207a2 2 0 0 1 2.828 0l3.879 3.879a2 2 0 0 1 0 2.828l-5.5 5.5A2 2 0 0 1 7.879 15H5.12a2 2 0 0 1-1.414-.586l-2.5-2.5a2 2 0 0 1 0-2.828zm.66 11.34L3.453 8.254 1.914 9.793a1 1 0 0 0 0 1.414l2.5 2.5a1 1 0 0 0 .707.293H7.88a1 1 0 0 0 .707-.293z"/>
                            </svg>
                            <strong> マイデザイン解除 </strong>
                        </Button>
                    </div>
                </CardBody>
            </Card>;
        } else {
            return <Card className="allocate-template-card" bg={"light"} text={"secondary"}>
                <CardBody>
                    <CardText>
                        オリジナルカードを割当してください。<br/>
                        <span>
                            ※未発送マイデザインカードが再利用できます。
                        </span>
                    </CardText>
                    <div className="my-design-allocate-buttons">
                        <Button variant={"primary"}
                                className={committed?'d-none':''}
                                onClick={onClickTemplate}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
                            </svg>
                            <strong className="pc"> 作成済から選ぶ </strong>
                            <strong className="sp"> 選択 </strong>
                        </Button>
                        <Button variant={"success"}
                                className={committed ? 'd-none' : ''}
                                onClick={onClickEntry}
                                style={{backgroundColor: '#0E95A4'}}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path
                                    d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z"/>
                            </svg>
                            <strong className="pc"> マイデザイン作成 </strong>
                            <strong className="sp"> 作成 </strong>
                        </Button>
                    </div>
                </CardBody>
            </Card>;
        }
    } else if (isMessageTemp(dto?.template_kbn)) {
        if (isNotEmpty(templateDto?.template_id)) {
            return <div className="template-choice-block">
                <OptionTemplateItem
                    template_dto={templateDto}
                    handleClick={onClickTemplate}
                ></OptionTemplateItem>
                <div className="my-design-allocate-buttons">
                    <Button variant={"danger"}
                            onClick={onClickDeallocate}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path
                                d="M8.086 2.207a2 2 0 0 1 2.828 0l3.879 3.879a2 2 0 0 1 0 2.828l-5.5 5.5A2 2 0 0 1 7.879 15H5.12a2 2 0 0 1-1.414-.586l-2.5-2.5a2 2 0 0 1 0-2.828zm.66 11.34L3.453 8.254 1.914 9.793a1 1 0 0 0 0 1.414l2.5 2.5a1 1 0 0 0 .707.293H7.88a1 1 0 0 0 .707-.293z"/>
                        </svg>
                        <strong className="pc"> マイデザイン解除 </strong>
                        <strong className="sp"> 解除 </strong>
                    </Button>
                    {templateDto?.has_assign_cards &&
                        <Button variant={"secondary"}
                                onClick={() => {
                                    openApplySitePreview(templateDto)
                                }}
                        >
                            <strong className="pc"> プレビュー </strong>
                            <strong className="sp"> 見る </strong>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                 className="bi bi-caret-right-fill" viewBox="0 0 16 16">
                                <path
                                    d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                            </svg>
                        </Button>
                    }
                </div>
            </div>;
        } else {
            return <Card className="allocate-template-card" bg={"light"} text={"secondary"}>
                <CardBody>
                    <CardText>
                        オンラインメッセージを割当してください。<br/>
                        <span>
                            ※割当しない場合は通常の画面を表示します。
                        </span>
                    </CardText>
                    <div className="my-design-allocate-buttons">
                        <Button variant={"primary"}
                                onClick={onClickTemplate}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
                            </svg>
                            <strong className="pc"> 作成済から選ぶ </strong>
                            <strong className="sp"> 選択 </strong>
                        </Button>
                        <Button variant={"success"}
                                onClick={onClickEntry}
                                style={{backgroundColor: '#0E95A4'}}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path
                                    d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z"/>
                            </svg>
                            <strong className="pc"> マイデザイン作成 </strong>
                            <strong className="sp"> 作成 </strong>
                        </Button>
                    </div>
                </CardBody>
            </Card>;
        }
    }else if(isWrapTemp(dto?.template_kbn)){
        if(committed && !isNotEmpty(templateDto?.template_id)){
            return <></>;
        }
        if(isNotEmpty(templateDto?.template_id)){
            return <div className="template-choice-block">
                <OptionTemplateItem
                    template_dto={templateDto}
                    disabled={committed}
                    handleClick={onClickTemplate}
                ></OptionTemplateItem>
            </div>;
        }else {
            return <Card className="allocate-template-card" bg={"light"} text={"secondary"}>
                <CardBody>
                    <CardText>
                        のし包装を割当してください。<br/>
                        <span>
                            ※サイトにより別料金が発生する場合があります。
                        </span>
                    </CardText>
                    <div className="my-design-allocate-buttons">
                        <Button variant={"primary"}
                                className={committed?'d-none':''}
                                onClick={onClickTemplate}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
                            </svg>
                            <strong className="pc"> 作成済から選ぶ </strong>
                            <strong className="sp"> 選択 </strong>
                        </Button>
                        <Button variant={"success"}
                                className={committed ? 'd-none' : ''}
                                onClick={onClickEntry}
                                style={{backgroundColor: '#0E95A4'}}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path
                                    d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z"/>
                            </svg>
                            <strong className="pc"> マイデザイン作成 </strong>
                            <strong className="sp"> 作成 </strong>
                        </Button>
                    </div>
                </CardBody>
            </Card>;
        }
    }else if(isQrSettingTemp(dto?.template_kbn)){
        if(seal_type || isNotEmpty(templateDto?.template_id)){
            return <div className="template-choice-block">
                <OptionTemplateItem
                    template_dto={templateDto}
                    seal_type={seal_type}
                    disabled={(seal_type || committed)}
                    handleClick={onClickTemplate}
                ></OptionTemplateItem>
            </div>;
        }
        if(committed){
            return <></>;
        }
        return <Card className="allocate-template-card" bg={"light"} text={"secondary"}>
            <CardBody>
                <CardText>
                    正方形・長方形の2種類をご用意しております。<br/>
                    <span>
                        ※ファイル（PDF・PNG）が選択可能です。
                    </span>
                </CardText>
                <div className="my-design-allocate-buttons">
                    <Button variant="success"
                            onClick={onClickTemplate}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"/>
                        </svg>
                        <strong> QR形状指定 </strong>
                    </Button>
                </div>
            </CardBody>
        </Card>;
    }else {
        return <></>;
    }
};
export default OrderDetailTemplate;